import * as React from 'react';

const SvgFileIcon = (props) => (
  <svg
    width={40}
    height={40}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.93}
      d='M20.003 3.333C10.803 3.333 3.336 10.8 3.336 20c0 9.2 7.467 16.667 16.667 16.667 9.2 0 16.666-7.467 16.666-16.667 0-9.2-7.466-16.667-16.666-16.667Zm7.283 20.584-3.7 3.7a4.54 4.54 0 0 1-3.233 1.333 4.582 4.582 0 0 1-4.584-4.567c0-1.216.484-2.383 1.35-3.233l2.35-2.35a1.257 1.257 0 0 1 1.767 0 1.257 1.257 0 0 1 0 1.767l-2.35 2.35a2.057 2.057 0 0 0 0 2.933 2.082 2.082 0 0 0 2.95 0l3.7-3.7a5.422 5.422 0 0 0-7.667-7.667l-4.033 4.034a4.428 4.428 0 0 0 0 6.3 1.257 1.257 0 0 1 0 1.766 1.257 1.257 0 0 1-1.767 0 6.75 6.75 0 0 1-2.066-4.9 6.92 6.92 0 0 1 2.033-4.933l4.033-4.033c3.084-3.084 8.117-3.084 11.2 0 3.1 3.083 3.1 8.116.017 11.2Z'
      fill='#ff0037'
    />
  </svg>
);

export default SvgFileIcon;
